<template>

  <div>
    <v-dialog v-model="toggled"
              :persistent="true"
              max-width="700px">
      <v-card>

        <p class="dialog-title">Custom Premium Status</p>

        <v-card-text v-if="user">

          <p align="center">
            An user with a Custom Premium status indefinitely has access to Rematch Premium features.
            <br/>
            You can revoke this status at any time.
          </p>
          <br/>

          <div class="dialog-row">
            <p>Username: </p>
            <p><b>{{ user.preferredUsername }}</b></p>
          </div>

          <div class="dialog-row">
            <p class="custom-txt">Custom Premium status: </p>
            <div class="switch-container">
              <v-switch v-model="customPremium"/>
            </div>
          </div>

          <!-- BUTTONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="close">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="save">Save</v-btn>
          </v-card-actions>

        </v-card-text>

      </v-card>
    </v-dialog>
  </div>

</template>

<script>

export default {
  name: 'PremiumManager',
  props: ['toggled', 'user'],
  data () {
    return {
      customPremium: false
    }
  },
  methods: {
    close () {
      this.$emit('closePremiumManager')
    },
    save () {
      if (this.customPremium !== this.user.is_premium_indefinitely) {
        if (this.customPremium) {
          this.$emit('setUserPremium', this.user.id)
        } else {
          this.$emit('unsetUserPremium', this.user.id)
        }
      } else {
        this.close()
      }
    }
  },
  watch: {
    'toggled' () {
      console.log(this.toggled)
      if (this.toggled) {
        this.customPremium = this.user.is_premium_indefinitely
      } else {
        this.customPremium = false
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .dialog-title {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-top: 20px;
  }

  .dialog-row {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 12px;
    align-items: center;
  }

  .custom-txt {
    margin: 0;
    padding-top: 6px;
  }

  .switch-container {
    max-height: 24px;
  }

</style>

<style lang="scss">

  .v-input--selection-controls {
    margin: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/PremiumManager.vue